import { SelectListItem } from './select-property'

export const Options_DataBase: SelectListItem[] = [
    { value: '1', text: 'Oracle', index: 1 },
    { value: '2', text: 'MSSQL', index: 2 },
    { value: '3', text: 'MongoDB', index: 3 }
];
